import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useToast } from './use-toast';
import { contactSchema, createEmptyContact, getContactError, getContactPayload } from '../lib/contactForm';

export const useContactForm = () => {
  const { toast } = useToast();
  const [form, setForm] = useState(createEmptyContact);
  const [submitting, setSubmitting] = useState(false);
  const request = useRef(null);
  useEffect(() => () => request.current?.abort(), []);

  const handleChange = useCallback((event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }, []);

  const handleSubmit = useCallback(async (event) => {
    event.preventDefault();
    if (request.current) return;
    const result = contactSchema.safeParse(form);
    if (!result.success) {
      toast({ title: 'Eksik bilgi', description: result.error.issues[0].message });
      return;
    }
    const controller = new AbortController();
    request.current = controller;
    setSubmitting(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, getContactPayload(result.data), {
        signal: controller.signal, timeout: 20000,
      });
      toast({ title: 'Mesajiniz iletildi', description: 'En kisa surede sizinle iletisime gececegiz.' });
      setForm(createEmptyContact());
    } catch (error) {
      if (!axios.isCancel(error)) toast({ title: 'Gonderim hatasi', description: getContactError(error), variant: 'destructive' });
    } finally {
      request.current = null;
      if (!controller.signal.aborted) setSubmitting(false);
    }
  }, [form, toast]);

  return { form, submitting, handleChange, handleSubmit };
};